<template>
<!-- OLD DIV VERSION    <div class="col-md-10 col-sm-9 col-md-offset-2 col-sm-offset-3 content container-fluid">-->
    <div class="col-lg-12 col-md-10 col-sm-9 content container-fluid">
        <div class="wrapper">
            <div class="container-wrapper">
                <div id="alerts-container">
                </div>
            </div>
        </div>
        <div class="row m-t-20">
            <div class="col-xs-12 p-b-10 b-b b-grey">
                <ul class="nav nav-tabs offer-tabs">
                    <li class="active b-r b-grey"><a data-toggle="tab" href="#product-info">PRODUCTOS</a></li>
                    <li><a data-toggle="tab" href="#history-info">HISTORIAL</a></li>
                </ul>
            </div>
            <!--tap content-->
            <div class="col-xs-12 m-t-20 tab-content">
                <!--products information-->
                <div class="tab-pane  active" id="product-info">
                    <div class="col-xs-12">
                        <div class="account-item">
                            <div class="panel panel-default">
                                <div class="panel-heading bg-primary">
                                    <h3 class="panel-title text-white">QUICKCASH</h3>
                                </div>
                                <div class="panel-body">
                                    <div class="table-responsive">
                                        <table class="table m-0">
                                            <thead>
                                                <tr>
                                                    <th>ID</th>
                                                    <th>Fecha</th>
                                                    <th style="min-width: 165px;">Descripción</th>
                                                    <th style="min-width: 183px;">Estado</th>
                                                    <th style="min-width: 270px;">Monto total</th>
                                                    <th>Saldo</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="product in products">
                                                    <template v-if="product.product_id == '1'">
                                                        <th scope="row">{{ product.id }}</th>
                                                        <td>{{ product.created_at }}</td>
                                                        <td>Solicitud de quickcash</td>
                                                        <td>{{ product.status_id == '1' ? 'Activo' : 'Saldado' }}</td>
                                                        <td>RD${{ product.principal_amount }}</td>
                                                        <td>RD${{ product.current_debt_amount }}</td>
                                                    </template> 
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="col-xs-12">
                        <div class="account-item">
                            <div class="panel panel-default">
                                <div class="panel-heading bg-primary">
                                    <h3 class="panel-title text-white">SUPERCASH</h3>
                                </div>
                                <div class="panel-body">
                                    <div class="table-responsive">
                                        <table class="table m-0">
                                            <thead>
                                                <tr>
                                                    <th>ID</th>
                                                    <th>Fecha</th>
                                                    <th style="min-width: 165px;">Descripción</th>
                                                    <th style="min-width: 183px;">Estado</th>
                                                    <th style="min-width: 270px;">Monto total</th>
                                                    <th>Saldo</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="product in products">
                                                    <template v-if="product.product_id == '2'">
                                                        <th scope="row">{{ product.id }}</th>
                                                        <td>{{ product.created_at }}</td>
                                                        <td>Solicitud de quickcash</td>
                                                        <td>{{ product.status_id == '1' ? 'Activo' : 'Saldado' }}</td>
                                                        <td>RD${{ product.principal_amount }}</td>
                                                        <td>RD${{ product.current_debt_amount }}</td>
                                                    </template> 
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="col-xs-12">
                        <div class="account-item">
                            <div class="panel panel-default">
                                <div class="panel-heading bg-primary">
                                    <h3 class="panel-title text-white">Cash Wallet</h3>
                                </div>
                                <div class="panel-body">
                                    <div class="table-responsive">
                                        <table class="table m-0">
                                            <thead>
                                                <tr>
                                                    <th>ID</th>
                                                    <th>Fecha</th>
                                                    <th style="min-width: 165px;">Descripción</th>
                                                    <th style="min-width: 183px;">Estado</th>
                                                    <th style="min-width: 270px;">Monto total</th>
                                                    <th>Saldo</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <th scope="row">#5050632</th>
                                                    <td>08/08/2016</td>
                                                    <td>Solicitud quickcash</td>
                                                    <td>Aprovado</td>
                                                    <td>RD$5,000.00</td>
                                                    <td>RD$0.00</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="col-xs-12">
                        <div class="account-item">
                            <div class="panel panel-default">
                                <div class="panel-heading bg-primary">
                                    <h3 class="panel-title text-white">Descuentos internos</h3>
                                </div>
                                <div class="panel-body">
                                    <div class="table-responsive">
                                        <table class="table m-0">
                                            <thead>
                                                <tr>
                                                    <th>ID</th>
                                                    <th>Fecha</th>
                                                    <th style="min-width: 165px;">Descripción</th>
                                                    <th style="min-width: 183px;">Estado</th>
                                                    <th style="min-width: 270px;">Monto total</th>
                                                    <th>Saldo</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <th scope="row">#5050632</th>
                                                    <td>08/08/2016</td>
                                                    <td>Solicitud quickcash</td>
                                                    <td>Aprovado</td>
                                                    <td>RD$5,000.00</td>
                                                    <td>RD$0.00</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                   
                </div>
                <!--/.products information-->
                <!-- history info-->
                <div class="tab-pane" id="history-info">
                    <!-- table filters-->
                    <div class="row">
                        <div class="col-xs-12 m-t-20">
                            <div class="form-group col-xs-12 col-lg-4">
                                <label>Producto</label>
                                <select class="full-width" data-init-plugin="select2">
                                    <optgroup>
                                        <option>Cash Wallet</option>
                                        <option>QUICKCASH</option>
                                        <option>SUPERCASH</option>
                                        <option>Descuentos internos</option>
                                    </optgroup>
                                </select>
                            </div>
                            
                            <div class="form-group col-xs-12 col-lg-4">
                                    <label>Desde</label>
                                    <div id="first-date" class="input-group date">
                                        <input type="text" class="form-control" placeholder="00/00/00">
                                        <span class="input-group-addon bg-white"><i class="fa fa-calendar"></i>
                                        </span>
                                    </div>
                                    
                                </div>
                                <div class="form-group col-xs-12 col-lg-4">
                                    <label>Hasta</label>
                                    <div class="input-group">
                                        <input type="text" class="form-control" placeholder="00/00/00">
                                        <span class="input-group-addon"><i class="fa fa-calendar"></i>
                                        </span>
                                    </div>
                                    
                                </div>
                        </div>
                    </div>
                    <!-- /.table filters-->
                    <hr>
                    <!-- table actions-->
                    <div class="row">
                        <div class="col-xs-12 m-t-20">
                            <div class="input-group transparent col-xs-12 col-lg-6  p-r-5 m-b-20 pull-left">
                                <input type="text" class="form-control f-text-md" placeholder="Buscar" id="search-btn" name="search-btn">
                                <span class="input-group-addon bg-white">
                                    <i class="md md-search sm-ico"></i>
                                </span>
                            </div>
                            <button class="btn btn-primary m-l-5 m-r-5"><i class="md  md-file-download sm-ico b-r b-white p-r-20 m-r-20"></i> DESCARGAR</button>
                            <button class="btn btn-primary m-l-5 m-r-5" data-toggle="modal" data-target="#table-config"><i class="md  md-settings sm-ico b-r b-white p-r-20 m-r-20"></i> CONFIGURACiÓN</button>
                        </div>
                    </div>
                    <!-- /.table actions-->
                    <!-- history table info-->
                    <div class="row">
                        <div class="col-xs-12 m-t-20">
                            <div class="table-responsive">
                                <table class="table m-0">
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Fecha</th>
                                            <th style="min-width: 165px;">Descripción</th>
                                            <th style="min-width: 183px;">No. de cuotas</th>
                                            <th style="min-width: 270px;">Monto total</th>
                                            <th>Monto restante</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <th scope="row">#5050632</th>
                                            <td>08/08/2016</td>
                                            <td>Solicitud quickcash</td>
                                            <td>6</td>
                                            <td>RD$5,000.00</td>
                                            <td>RD$5,000.00</td>
                                        </tr>
                                        
                                        <tr>
                                            <th scope="row">#5050632</th>
                                            <td>08/08/2016</td>
                                            <td>Solicitud quickcash</td>
                                            <td>6</td>
                                            <td>RD$5,000.00</td>
                                            <td>RD$5,000.00</td>
                                        </tr>
                                        
                                        <tr>
                                            <th scope="row">#5050632</th>
                                            <td>08/08/2016</td>
                                            <td>Solicitud quickcash</td>
                                            <td>6</td>
                                            <td>RD$5,000.00</td>
                                            <td>RD$5,000.00</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    
                </div>
                <!-- /.history table info-->
            </div>
            <!-- /.tap content end-->
        </div>
    <!-- <h2>QuickCash</h2>
    <div class="table-responsive">
        <table class="table">
            <thead>
                <tr>
                    <th>ID</th>
                    <th>Fecha</th>
                    <th>Descripcion</th>
                    <th>Estado</th>
                    <th>Monto total</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="product in products">
                    <template v-if="product.product_id == '1'">
                        <td>{{ product.id }}</tr>
                        <td>{{ product.start_date }} </td>
                        <td>Sotdcitud de quickcash</td>
                        <td>{{ product.status_id == '1' ? 'Activo' : 'Saldado' }}</td>
                        <td>{{product.principal_amount }} </td>    
                    </template>        
                </tr>
            </tbody>
        </table>
    </div>
    <h2>SuperCash</h2>
    <div class="table-responsive">
        <table class="table">
            <thead>
                <tr>
                    <th>ID</th>
                    <th>Fecha</th>
                    <th>Descripcion</th>
                    <th>Estado</th>
                    <th>Monto total</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="product in products">
                    <template v-if="product.product_id == '2'">
                        <td>{{ product.id }}</tr>
                        <td>{{ product.start_date }} </td>
                        <td>Sotdcitud de supercash</td>
                        <td>{{ product.status_id == '1' ? 'Activo' : 'Saldado' }}</td>
                        <td>{{product.principal_amount }} </td>    
                    </template>        
                </tr>
            </tbody>
        </table>
    </div> -->
    </div>
</template>

<script>
export default {
    data() {
        return {
            products: [],
            clientId: this.$route.params.id,
        }
    },
        created() {
            this.loansRequested();
        },
        methods: {
            loansRequested: function() {
                this.$http.get(apiUrl+'/loan-requests/'+this.clientId).then(response => {
                this.products = response.data;
                });
            },  
        },
    }
</script>


// WEBPACK FOOTER //
// list-products.vue?7b5d77e2